import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import formUrlEncoded from 'form-urlencoded';

class Register extends Component {

    registerNewUser( ev ) {
        ev.preventDefault();

        const userData = {
            email_address: this.refs.email.value,
            password: this.refs.password.value,
        };

        fetch('http://dev.intouchnetworks.com/authentication/token/', {
            method: 'POST',
            body: formUrlEncoded( userData ),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        } )
            .then( ( response ) => {
                if( !response.ok ) {
                    // handle response
                }

                return response.json();
            } )
            .then( ( response ) => {
                if( response.success ) {
                    browserHistory.push('/');
                } else {
                    browserHistory.push('/login');
                    this.refs.loginForm.reset();
                }
            } )
            .catch( ( error ) => {

            } );
    };

    render() {
        return (
            <article className="Site-content container login-body">
                <div className="row">
                    <div className="col-xs-12">
                        <h1 className="h1 text-center">Register</h1>
                        <form className="login-form" ref="loginForm">
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <label htmlFor="email">First Name</label>
                                </div>
                                <div className="col-xs-12 col-md-8">
                                    <input type="text" id="firsName" ref="firstName" placeholder="First Name"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <label htmlFor="email">Last Name</label>
                                </div>
                                <div className="col-xs-12 col-md-8">
                                    <input type="text" id="lastName" ref="lastName" placeholder="Last Name"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <label htmlFor="email">Telephone Number</label>
                                </div>
                                <div className="col-xs-12 col-md-8">
                                    <input type="text" id="telephone" ref="telephone" placeholder="Telephone number"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <label htmlFor="email">Email Address</label>
                                </div>
                                <div className="col-xs-12 col-md-8">
                                    <input type="text" id="email" ref="email" placeholder="Email address"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <label htmlFor="password">Password</label>
                                </div>
                                <div className="col-xs-12 col-md-8">
                                    <input type="password" id="password" ref="password" placeholder="Password"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-8 col-md-offset-4">
                                    <ul className="buttons-right">
                                        <li>
                                            <button className="btn btn-secondary" type="submit"
                                                    onClick={ () => this.registerNewUser() }>Register
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </article>
        );
    };
}

export default Register;



// WEBPACK FOOTER //
// src/client/components/common/authentication/Register.js